import React from 'react';
export var AssetsContext = React.createContext({
    spritesheets: {},
    maps: {}
});
AssetsContext.displayName = 'AssetsContext';
export var useAssets = function () { return React.useContext(AssetsContext); };
